import { gql } from '@apollo/client';
export const REGISTER_MUTATION = gql`
  mutation RegisterMutation($data: UsersPermissionsRegisterInput!) {
    register(input: $data) {
      jwt
      user {
        id
        username
        email
      }
    }
  }
`;
